import { HttpInterceptors } from "./http.interceptor";

export class PaySubscriptionService extends HttpInterceptors {
	async checkPaymentIdUser (payload) {
		const response = await this.axios.post("paySubscription/checkPaymentIdUser", payload);
		return response.data;
	}

	async checkPayment (payload) {
		const response = await this.axios.post("paySubscription/checkPayment", payload);
		return response.data;
	}
}